import { buildApiClient } from '@roo/api';
import axios from './axiosInstance';

const baseUrl: string = process.env.REACT_APP_BASE_URL;

export const apiProvider = buildApiClient(baseUrl, axios);
